module.exports = __webpack_public_path__ + "static/Firewatch7-8258251af8eef2c9e6a641d88b0032f3.webp";